export const IS_PROD_ENV = process.env.NODE_ENV === 'production';
export const API_SERVER = process.env.VITE_API_SERVER ?? '';
//if we see 0.0.0 in logs or amplitude we know the env files have broken;
export const VERSION = process.env.VITE_UNANET_APP_VERSION ?? '0.0.0';

//// Dev settings TODO AW: rollup, webpack, process.env, vite zomg
// export const IS_PROD_ENV = true;
// export const API_SERVER = 'http://localhost:9082/unanet/rest';
// export const VERSION = '0.0.0';

export const context =
  window.location.pathname.split('/').filter(Boolean)[0] ?? '';
